import { render, staticRenderFns } from "./AudioList.vue?vue&type=template&id=7165e75c&"
import script from "./AudioList.vue?vue&type=script&lang=ts&"
export * from "./AudioList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports